import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useSettings } from "../context/SettingsContext";

export default function ProtectedRoute({ children, adminOnly = false, staffOnly = false }) {
  const { user, loading } = useAuth();
  const { settings } = useSettings();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-slate-500 uppercase tracking-[0.3em] text-xs font-display" data-testid="auth-loading">Loading</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Non-admins are redirected to /maintenance while the site is offline.
  // Staff (mods) still get to work during maintenance.
  const isStaff = user.role === "admin" || user.role === "moderator";
  if (settings?.maintenance_enabled && !isStaff) {
    return <Navigate to="/maintenance" replace />;
  }
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (staffOnly && !isStaff) return <Navigate to="/dashboard" replace />;
  return children;
}
